import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog4.css';
import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/blog16.jpeg';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div className="blog-hero" style={{ backgroundImage: `url(${blogImage})` }}>
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">The Impact of Technology in Education</h2> <br />
          <div className="published-badge">Published on: 05 August 2025</div><br />

          <img src={blog1} alt="The Impact of Technology in Education" className="blog-detail-img" />

          <div className="blog-detail-content">
            <p><strong>The Impact of Technology in Education</strong></p>
            <p>
              In today’s fast-evolving world, technology has revolutionized education, opening new horizons for both students and teachers. 
              As one of the best schools in Vadodara, Redschool House embraces this transformation, blending innovative learning tools 
              with an inspiring environment to nurture young minds for the future.
            </p>

            <p><strong>How Technology is Transforming Education</strong></p>
            <ul>
              <li><strong>Access to Information:</strong> The internet and digital platforms have made a wealth of knowledge instantly accessible. Students are no longer confined to textbooks—they can explore online resources, virtual libraries, and interactive courses, sparking curiosity and a love for learning.</li><br />
              <li><strong>Interactive & Engaging Learning:</strong> Smart classrooms, educational apps, and multimedia content make lessons more engaging. Visual aids and gamified platforms bring even the most difficult concepts to life.</li><br />
              <li><strong>Personalized Learning:</strong> With adaptive software, each child’s learning journey is unique. Technology enables personalized lesson plans, instant feedback, and self-paced progress.</li><br />
              <li><strong>Enhanced Collaboration:</strong> Collaborative platforms and video tools allow students to work together, exchange ideas, and communicate beyond the classroom.</li><br />
              <li><strong>Preparation for the Digital Age:</strong> Introducing technology in education ensures students become tech-savvy and ready for tomorrow’s workforce.</li><br />
              <li><strong>Efficient Assessment:</strong> Online quizzes and real-time feedback help teachers track progress quickly and save time.</li><br />
              <li><strong>Cost-effective & Eco-friendly:</strong> Digital materials reduce the need for printed books and infrastructure, making learning sustainable.</li><br />
            </ul>

            <p><strong>At Redschool House Vadodara: How We Lead</strong></p>
            <ul>
              <li><strong>Joyful, Play-Based Learning:</strong> Integrating smart learning tools from early years to spark creativity.</li><br />
              <li><strong>Parent-Teacher Collaboration:</strong> Digital communication keeps parents updated and engaged.</li><br />
              <li><strong>Skill-Based Development:</strong> We use technology to foster communication, teamwork, and problem-solving.</li><br />
            </ul>

            <p><strong>Why Redschool House is the Smart Choice in Vadodara</strong></p>
            <p>
              Choosing Redschool House means giving your child the advantage of 21st-century education in an environment 
              trusted by parents and designed for holistic growth. Technology is not just a tool—it’s a bridge to a smarter future.
            </p>

            <p><strong>Are you ready to give your child an education that combines tradition with technology? Visit Redschool House in Vadodara today!</strong></p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
